import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import Valkyrie, { viGear } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

export default function PbxCard({ pbx }) {
  return (
    <Card variant="outlined">
      <List>
        <ListItem
          disablePadding
          id={`recent-pbx-${pbx.id}`}
          secondaryAction={
            <IconButton component={NavLink} to={`/pbx/${pbx.context}/my-pbx`}>
              <Valkyrie icon={viGear} />
            </IconButton>
          }
        >
          <ListItemButton component={NavLink} to={`/pbx/${pbx.context}/dashboard`} sx={{ borderRadius: 0 }}>
            <ListItemAvatar>
              <Avatar text={pbx.name} />
            </ListItemAvatar>
            <ListItemText primary={pbx.name} secondary={pbx.context} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

PbxCard.propTypes = {
  pbx: PropTypes.object,
};
